import { AlertCircle, ArrowLeft, Loader2, Monitor } from 'lucide-react';

import { Button } from '@/components/ui/button';

export type MobileQuoteGateStatus = 'loading' | 'loaded' | 'error';

interface MobileQuoteDesktopNoticeProps {
  status: MobileQuoteGateStatus;
  onReturnToOverview: () => void;
}

export default function MobileQuoteDesktopNotice({
  status,
  onReturnToOverview,
}: MobileQuoteDesktopNoticeProps) {
  const isLoading = status === 'loading';
  const isError = status === 'error';

  return (
    <main className="min-h-screen bg-gradient-to-b from-blue-50 via-white to-white px-5 py-10 flex items-center justify-center">
      <section
        className="w-full max-w-md rounded-2xl border border-blue-100 bg-white p-6 shadow-lg"
        data-testid="mobile-quote-desktop-notice"
      >
        <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50">
          {isLoading ? (
            <Loader2 className="h-6 w-6 animate-spin text-blue-600" aria-hidden="true" />
          ) : isError ? (
            <AlertCircle className="h-6 w-6 text-red-600" aria-hidden="true" />
          ) : (
            <Monitor className="h-6 w-6 text-blue-600" aria-hidden="true" />
          )}
        </div>

        <h1 className="text-xl font-semibold text-gray-950">
          {isLoading
            ? 'Bestehendes Angebot wird geladen'
            : isError
              ? 'Angebot konnte nicht geladen werden'
              : 'Bearbeitung derzeit am Desktop'}
        </h1>
        <p className="mt-3 text-sm leading-6 text-gray-600">
          {isLoading
            ? 'Einen Moment bitte. Das gespeicherte Angebot wird sicher geöffnet.'
            : isError
              ? 'Bitte kehren Sie zur Übersicht zurück und versuchen Sie es später erneut.'
              : 'Dieses bestehende Angebot kann mobil noch nicht sicher bearbeitet werden. Öffnen Sie es am Desktop oder kehren Sie zur Übersicht zurück.'}
        </p>

        {!isLoading && (
          <Button
            type="button"
            variant="outline"
            className="mt-6 w-full"
            onClick={onReturnToOverview}
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Zurück zur Übersicht
          </Button>
        )}
      </section>
    </main>
  );
}
